/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "./define-slots.styles.scss";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import {
  selectCrops,
  selectSelectedCrop,
  selectBranches,
  selectCurrentPage,
  selectFreezingTime,
  selectSelectedBranch,
  selectClosingDuration,
  selectSlotPage,
  selectViewAuctionPage,
} from "../../redux/common/common.selectors";
// import { setBranchIndex } from "../../redux/common/common.actions";
import {
  ExclamationCircleOutlined,
  // SyncOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Dispatch } from "redux";

import {
  Button,
  Checkbox,
  Spin,
  Modal,
  message,
  Flex,
  Space,
  Row,
  Col,
  TimePicker,
} from "antd";
// import { getCompanyParams } from "../../services/sys-params-services";

import {
  getSlotServiceMaster,
  postAddSlotMaster,
  putUpdateSlotMaster,
} from "../../services/define-slot-services";
// import { getSysParams } from "../../services/sys-params-services";

import SlotTime from "../../components/slot-time/slot-time.component";
import CustomSelect from "../../components/custom-select/custom-select.component";

import { FeatureCodes } from "../../constants/data-constants";
import { canUserAccess } from "../../utils/utils";

import dayjs from "dayjs";
import {
  selectAuthData,
  selectUserData,
} from "../../redux/user/user.selectors";
import {
  setSelectedBranch,
  setSelectedCrop,
} from "../../redux/common/common.actions";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useLocation } from "react-router";

dayjs.extend(customParseFormat);
const { RangePicker } = TimePicker;

interface ISlots {
  end_time: string;
  slot_id: number;
  start_time: string;
}
interface IStateSlots {
  slot_id: number;
  slot_number: number;
  // auction_freeze_period: number;
  value: Array<string>;
  active: boolean;
  permanent: boolean;
  edited: boolean;
}
interface IGetResponseObject {
  end_time: string;
  is_active: boolean;
  master: boolean;
  slot_id: number;
  slot_number: number;
  start_time: string;
}
const DefineSlot: React.FC<any> = (props: any) => {
  const {
    branches,
    user,
    crops,
    selectedCrop,
    currentpage,
    slotPageIndex,
    freezingTime,
    selectedBranch,
    setSelectedBranchIndex,
    setSelectedCropIndex,
    bufferTime,
    viewAuctionPage,
    authData,
  } = props;

  const [slots, setSlots] = useState<IStateSlots[]>([]);
  const [isEdit, setIsEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [slotToPost, setSlotToPost] = useState(["", ""]);
  const location = useLocation();
  useEffect(() => {
    if (
      location.pathname.includes("/preferences/auctionslots") &&
      slotPageIndex === "701"
    ) {
      getSlotsFn();
    }
  }, [
    authData.access_token,
    currentpage,
    slotPageIndex,
    viewAuctionPage,
    selectedBranch,
    selectedCrop,
  ]);

  const getSlotsFn = async () => {
    setLoader(true);
    const params = {
      branch_id: selectedBranch,
      crop_id: selectedCrop,
    };
    try {
      const slotsResponse = await getSlotServiceMaster(params);
      if (slotsResponse.status) {
        setSlotData([]);
        setSlotData(slotsResponse.data.data);
      } else {
        setSlotData([]);
      }
    } catch (error) {
      console.log(error);
      // if (error.response.status === 400) setSlotData([]);
    }
    setLoader(false);
  };

  const setSlotData = (data: Array<IGetResponseObject>) => {
    const updatedSlots = data.map((slot: IGetResponseObject) => {
      return {
        slot_id: slot.slot_id,
        slot_number: slot.slot_number,
        value: [slot.start_time, slot.end_time],
        active: slot.is_active,
        permanent: slot.master,
        edited: false,
      };
    });
    setSlots(updatedSlots);
  };

  const onChange = (id: number, timeString: Array<string>) => {
    const tempSlot = slots.map((item) => {
      if (item.slot_id === id) {
        item.value = [
          dayjs(timeString[0], "hh:mm A").format("HH:mm:ss"),
          dayjs(timeString[1], "hh:mm A").format("HH:mm:ss"),
        ];
        item.edited = true;
      }
      return item;
    });
    setSlots(tempSlot);
  };

  const onChangeAddSlot = (id: number, timeString: Array<string>) => {
    setSlotToPost(timeString);
  };

  const onAddSlotSubmit = async () => {
    const postData = {
      branch_id: selectedBranch,
      start_time: dayjs(slotToPost[0], "hh:mm A").format("HH:mm:ss"),
      end_time: dayjs(slotToPost[1], "hh:mm A").format("HH:mm:ss"),
      crop_id: selectedCrop,
    };

    let valid = true;
    let messageString = "";
    const validate = () => {
      if (postData.start_time === "" && postData.end_time === "") {
        messageString = "Please select a time..!";
        return false;
      }
      if (postData.start_time === postData.end_time) {
        messageString = "Time should not be same..!";
        return false;
      }
      const buffer = dayjs.duration(dayjs("00:00").format("HH:mm")).asMinutes();
      slots.map((item) => {
        // #region Check for intersect of time range
        // const itemRange = dayjs.range(
        //   dayjs(item.value[0], "HH:mm:ss"),
        //   dayjs(item.value[1], "HH:mm:ss").add(buffer, "m")
        // );
        // const newRange = dayjs.range(
        //   dayjs(slotToPost[0], "hh:mm A"),
        //   dayjs(slotToPost[1], "hh:mm A").add(buffer, "m")
        // );
        const itemStart = dayjs(item.value[0], "HH:mm:ss");
        const itemEnd = dayjs(item.value[1], "HH:mm:ss").add(buffer, "minute");

        const newStart = dayjs(slotToPost[0], "HH:mm:ss");
        const newEnd = dayjs(slotToPost[1], "HH:mm:ss").add(buffer, "minute");

        const intersects =
          itemStart.isBefore(newEnd) && newStart.isBefore(itemEnd);
        // if (itemRange.intersect(newRange)) {
        if (intersects) {
          messageString = "Time selected is overlaping an existing slot!";
          valid = false;
          return;
        }
      });
      if (valid) {
        return true;
      }
      return false;
    };

    if (validate()) {
      setIsSubmitting(true);
      try {
        const postResponse = await postAddSlotMaster(postData);
        if (postResponse.data.status) {
          message.success("Slot added successfully..!", 1);
          getSlotsFn();
          setAddModalVisible(false);
        } else {
          console.log("Something went wrong !");
        }
      } catch (error: any) {
        console.log(error);
        message.error(error.response.data.message, 1);
        setIsSubmitting(false);
      }
    } else {
      message.warning(messageString, 2);
    }
    setIsSubmitting(false);
  };

  const onToggle = (id: number) => {
    const tempSlot = slots.map((item) => {
      if (item.slot_id === id) {
        item.active = !item.active;
        item.edited = true;
      }
      return item;
    });
    setSlots(tempSlot);
  };

  const updateSlots = async () => {
    let dataToSend = {
      branch_id: selectedBranch,
      modified_slots: [{}],
    };
    const data = slots.filter((item) => item.edited);
    let valid = true;
    let messageString = "";

    dataToSend.modified_slots = data.map((item) => {
      return {
        slot_id: item.slot_id,
        start_time: item.value[0],
        end_time: item.value[1],
        is_active: item.active,
        is_today: false,
      };
    });

    const validate = () => {
      if (data.length === 0) {
        messageString = "Nothing to update...";
        valid = false;
        return;
      }

      slots.map((modifiedItem) => {
        if (modifiedItem.value[0] === "" || modifiedItem.value[1] === "") {
          valid = false;
          messageString = "Please select a time...";
          return;
        }
        if (modifiedItem.value[0] === modifiedItem.value[1]) {
          messageString = "Time should not be same..!";
          valid = false;
          return;
        }
        // const buffer = dayjs
        //   .duration(dayjs(bufferTime).format("HH:mm"))
        //   .asMinutes();
        const buffer = dayjs
          .duration(dayjs("00:00").format("HH:mm"))
          .asMinutes();
        slots.map((item) => {
          if (modifiedItem.slot_id !== item.slot_id) {
            // const itemRange = dayjs.range(
            //   dayjs(item.value[0], "HH:mm:ss"),
            //   dayjs(item.value[1], "HH:mm:ss").add(buffer, "m")
            // );
            // const newRange = dayjs.range(
            //   dayjs(modifiedItem.value[0], "HH:mm:ss"),
            //   dayjs(modifiedItem.value[1], "HH:mm:ss").add(buffer, "m")
            // );
            const itemStart = dayjs(item.value[0], "HH:mm:ss");
            const itemEnd = dayjs(item.value[1], "HH:mm:ss").add(
              buffer,
              "minute"
            );

            const newStart = dayjs(modifiedItem.value[0], "HH:mm:ss");
            const newEnd = dayjs(modifiedItem.value[1], "HH:mm:ss").add(
              buffer,
              "minute"
            );

            const intersects =
              itemStart.isBefore(newEnd) && newStart.isBefore(itemEnd);
            if (intersects) {
              messageString = "Time selected is overlaping an existing slot..!";
              valid = false;
              return;
            }
          }
        });
      });
      if (valid) {
        return true;
      } else {
        return false;
      }
    };

    if (validate()) {
      CheckSlotsForTodayPresent(data, dataToSend);
    } else {
      message.warning(messageString, 2);
      if (data.length === 0) {
        setIsEdit(false);
      }
    }
  };

  const CheckSlotsForTodayPresent = (data: any, dataToSend: any) => {
    let isAnyUpcomingSlotPresent = false;
    let isUpcomingSlotsInactive = false;
    for (let i = 0; i < data.length; i++) {
      if (dayjs(data[i].value[0], "HH:mm:ss").isAfter(dayjs())) {
        isAnyUpcomingSlotPresent = true;
        // setIsUpcomingSlots(true);
        break;
      }
    }

    if (isAnyUpcomingSlotPresent) {
      for (let i = 0; i < data.length; i++) {
        if (!data[i].active) {
          isUpcomingSlotsInactive = true;
          break;
        }
      }
    }

    // updateSlotsConditionally(dataToSend, true);
    if (isAnyUpcomingSlotPresent) {
      showPromiseConfirm(dataToSend, isUpcomingSlotsInactive);
    } else {
      updateSlotsConditionally(dataToSend, true);
    }
  };

  const updateSlotsConditionally = async (
    dataToSend: any,
    isToday: boolean
  ) => {
    let modifiedDataToSend = { ...dataToSend, crop_id: selectedCrop };
    if (isToday) {
      modifiedDataToSend = {
        ...modifiedDataToSend,
        modified_slots: modifiedDataToSend.modified_slots.map((item: any) => {
          return { ...item, is_today: true };
        }),
      };
    } else {
      modifiedDataToSend = {
        ...modifiedDataToSend,
        modified_slots: modifiedDataToSend.modified_slots.map((item: any) => {
          if (dayjs(item.start_time, "HH:mm:ss").isAfter(dayjs())) {
            return { ...item, is_today: false };
          } else {
            return { ...item, is_today: true };
          }
        }),
      };
    }

    try {
      const response = await putUpdateSlotMaster(modifiedDataToSend);
      if (response.data.status) {
        message.success(`Updated master slots..!`);
        getSlotsFn();
      } else {
        message.warning("Could not update master slots..!");
      }
    } catch (error: any) {
      message.error(error.response.data.message, 1);
    }
  };

  const closeUpdateModal = async () => {
    await getSlotsFn();
    Modal.destroyAll();
  };

  function showConfirmWarning(dataToSend: any) {
    Modal.confirm({
      title: "Slot allotment",
      icon: <ExclamationCircleOutlined />,
      content:
        "If auctions exist then all auctions will be cancelled. Are you sure ?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        updateSlotsConditionally(dataToSend, true);
      },
      onCancel() {
        getSlotsFn();
      },
    });
  }

  function showPromiseConfirm(
    dataToSend: any,
    isUpcomingSlotsInactive: boolean
  ) {
    Modal.confirm({
      title: (
        <div>
          <div>Slot allotment</div>
          <div className="slot-confirm-close-icon">
            <CloseCircleOutlined onClick={() => closeUpdateModal()} />
          </div>
        </div>
      ),
      icon: <ExclamationCircleOutlined />,
      content: "Is the change applicable from today ?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        if (isUpcomingSlotsInactive) {
          showConfirmWarning(dataToSend);
        } else {
          updateSlotsConditionally(dataToSend, true);
        }
      },
      onCancel() {
        updateSlotsConditionally(dataToSend, false);
      },
    });
  }

  return (
    <div className="define-slots">
      {/* <Modal
        className="add-slot-modal"
        open={addModalVisible}
        onCancel={() => setAddModalVisible(false)}
        onOk={() => setAddModalVisible(false)}
        footer={null}
        width="448px"
      >
        <div className="add-slot-container">
          <div className="add-slot-header">Add Slot</div>
          <div className="add-slot-content">
            <SlotTime
              slotId={1}
              slotNumber={
                slots.length !== 0 ? slots[slots.length - 1].slot_number + 1 : 1
              }
              value={slotToPost}
              onChange={onChangeAddSlot}
              isEdit={true}
              onToggle={onToggle}
              addSlot
            />
            <div className="btn-container">
              <Button loading={isSubmitting} onClick={onAddSlotSubmit}>
                Submit
              </Button>
            </div>
          </div>
        </div>
      </Modal> */}
      <Spin spinning={loader}>
        {freezingTime !== 0 && (
          <div className="label">
            <b>
              NOTE: Auction cannot be created {freezingTime} minutes before the
              slot start time.
            </b>
          </div>
        )}
        <Flex gap={10} justify="space-between" wrap>
          <Space>
            <CustomSelect
              options={crops}
              value={selectedCrop}
              onChange={(value: any) => setSelectedCropIndex(value)}
              returnId
            />
            <CustomSelect
              options={branches}
              value={selectedBranch}
              onChange={(value: any) => setSelectedBranchIndex(value)}
              returnId
            />
          </Space>
          {canUserAccess(user, FeatureCodes.SLOTS) && (
            <div className="add-slot-top-container">
              {isEdit ? (
                <Button
                  onClick={() => {
                    updateSlots();
                  }}
                  size="middle"
                  style={{
                    background: "rgba(18, 50, 116, 1)",
                    color: "#ffffff",
                  }}
                  disabled={canUserAccess(
                    user,
                    FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
                  )}
                >
                  Update Master Time
                </Button>
              ) : (
                <Space>
                  <RangePicker
                    // {...(slotToPost &&
                    //   slotToPost.length === 2 &&
                    //   slotToPost[0] !== "" && {
                    //     defaultValue: [
                    //       dayjs(slotToPost[0], "HH:mm:ss"),
                    //       dayjs(slotToPost[1], "HH:mm:ss"),
                    //     ],
                    //   })}
                    onChange={(value, timeString) =>
                      onChangeAddSlot(1, timeString)
                    }
                    format={"hh:mm A"}
                    minuteStep={5}
                    inputReadOnly={true}
                  />
                  <Button
                    loading={isSubmitting}
                    disabled={
                      canUserAccess(
                        user,
                        FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
                      ) ||
                      (slots.length !== 0 &&
                        (!slots[slots.length - 1].active || isEdit))
                    }
                    onClick={onAddSlotSubmit}
                    size="middle"
                    style={{
                      background: "rgba(18, 50, 116, 1)",
                      color: "#ffffff",
                    }}
                  >
                    Add Slot
                  </Button>
                </Space>
              )}
              {slots.length !== 0 && (
                <Button
                  className="edit-button"
                  onClick={() => {
                    setIsEdit(!isEdit);
                  }}
                  disabled={canUserAccess(
                    user,
                    FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
                  )}
                  icon={!isEdit && <EditOutlined />}
                  danger={isEdit}
                  size="middle"
                >
                  {!isEdit ? "Edit" : "Cancel"}
                </Button>
              )}
            </div>
          )}
        </Flex>
        <Row>
          {slots.map((item, idx) => (
            <Col sm={24} md={8} lg={isEdit ? 7 : 6}>
              <SlotTime
                key={idx}
                slotId={item.slot_id}
                slotNumber={item.slot_number}
                value={item.value}
                onChange={onChange}
                isEdit={isEdit}
                edited={item.edited}
                active={item.active}
                onToggle={onToggle}
                isPermanent={item.permanent}
                activeToggle
              />
            </Col>
          ))}
        </Row>
      </Spin>
    </div>
  );
};
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setSelectedBranchIndex: (index: number) =>
      dispatch(setSelectedBranch(index)),
    setSelectedCropIndex: (index: number) => dispatch(setSelectedCrop(index)),
  };
};
const mapStateToProps = createStructuredSelector({
  branches: selectBranches,
  user: selectUserData,
  crops: selectCrops,
  selectedCrop: selectSelectedCrop,
  currentpage: selectCurrentPage,
  slotPageIndex: selectSlotPage,
  freezingTime: selectFreezingTime,
  selectedBranch: selectSelectedBranch,
  bufferTime: selectClosingDuration,
  viewAuctionPage: selectViewAuctionPage,
  authData: selectAuthData,
});

export default connect(mapStateToProps, mapDispatchToProps)(DefineSlot);
